import PropTypes from 'prop-types';

import {Flex, Box} from '@salesforce/retail-react-app/app/components/shared/ui';

import {Component} from '@amblique/king-living/app/components/contentful/component';

/**
 * Split Panel 65/35
 *
 * @typedef {import('@chakra-ui/styled-system').SystemStyleObject} SystemStyleObject
 * @typedef {"root"} SectionPanelParts
 * @typedef {Partial<Record<SectionPanelParts, SystemStyleObject>>} SectionPanelStyles
 *
 * @param {Object} props - Component props
 * @param {Contentful.SectionPanel} props.component - SectionPanel component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @param {SectionPanelStyles} [props.styles] - Whether additional data is being fetched
 * @returns {React.ReactElement}
 */
export const SplitPanel6535 = ({component, isComplete = true, isFetching = false, styles, ...props}) => {
  const {contentCollection} = component;

  if (!contentCollection?.items) {
    return null;
  }

  const validItems = contentCollection.items.filter(
    (item) => item != null && typeof item === 'object' && item.__typename && item.sys?.id
  );

  if (validItems.length === 0) {
    return null;
  }

  return (
    <Flex {...styles.container} {...props}>
      {validItems.map((item, index) => (
        index === 0 ? (
          <Box key={item.sys.id} {...styles.leftRegion}>
            <Component key={item.sys.id} component={item} isComplete={isComplete} isFetching={isFetching} styles={styles} />
          </Box>
        ) : index === 1 ? (
          <Box key={item.sys.id} {...styles.rightRegion}>
            <Component key={item.sys.id} component={item} isComplete={isComplete} isFetching={isFetching} styles={styles} />
          </Box>
        ) : null
      ))}
    </Flex>
  );
};

SplitPanel6535.displayName = 'SplitPanel6535';
SplitPanel6535.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
  styles: PropTypes.object.isRequired,
};
